import React, { useState, useEffect, useMemo } from "react";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { LuPencil } from "react-icons/lu";
import { IoBan } from "react-icons/io5";
import { GoTrash } from "react-icons/go";
import { MdClose } from "react-icons/md";
import HeaderFilter from "../../Dashboard/DashboardTable/HeaderFilter";
import Pagination from "./Pagination";
import { IoAdd } from "react-icons/io5";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DeleteVec from "../../../../../Assets/Images/deleteVec.png";
import BlockVec from "../../../../../Assets/Images/blockVec.png";
import { getApiCaller } from "../../../../../Libs/apiCaller";
import { allCountries } from "country-telephone-data";
import profile_Img from "../../../../../Assets/Images/profile_Img.png";

const userData = [
  {
    name: "Emily Rose",
    email: "emilyRose@toner.com",
    phone: "+91 987 654 3210",
    date: "02 Jan, 2023",
    country: "United States",
    avatar: "https://i.pravatar.cc/150?img=1",
    gender: "Female",
    lastSeen: "13 Apr, 2025",
    about: <IoDocumentTextOutline className="text-xl" />,
  },
  {
    name: "Edward Davidson",
    email: "EdwardDavidson@toner.com",
    phone: "+1 987 654 3210",
    date: "05 Jan, 2023",
    country: "Canada",
    avatar: "https://i.pravatar.cc/150?img=2",
    gender: "Male",
    lastSeen: "12 Apr, 2025",
    about: <IoDocumentTextOutline className="text-xl" />,
  },
  // Add more users as needed
];

export default function UserListTable({
  openAddUserModal,
  setSelectedUser,
  userList,
  isLoading,
  getUserList,
  currentPage,
  totalPages,
  totalUsers,
  deleteUser,
  selectedTime,
  setSelectedTime,
}) {
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [isMenuOpen, setIsMenuOpen] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const sortedData = useMemo(() => {
    return [...userList].sort((a, b) => {
      if (sortConfig.key === "createdAt") {
        return sortConfig.direction === "asc"
          ? new Date(a.createdAt) - new Date(b.createdAt)
          : new Date(b.createdAt) - new Date(a.createdAt);
      }
      if (sortConfig.key === "countryCode") {
        return sortConfig.direction === "asc"
          ? a.countryCode.localeCompare(b.countryCode)
          : b.countryCode.localeCompare(a.countryCode);
      }
      if (a[sortConfig.key].toLowerCase() < b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key].toLowerCase() > b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [sortConfig, userList]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const toggleMenu = (index) => {
    setIsMenuOpen(isMenuOpen === index ? null : index);
  };

  const openModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(true);
    } else if (type === "block") {
      setIsBlockModalOpen(true);
    } else if (type === "delete") {
      setIsDeleteModalOpen(true);
    }
  };

  const closeModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(false);
    } else if (type === "block") {
      setIsBlockModalOpen(false);
    } else if (type === "delete") {
      setIsDeleteModalOpen(false);
    }
  };

  const getCountryFromPhoneCode = (code) => {
    const phoneCode = code.replace("+", "");
    const match = allCountries.find((c) => c.dialCode === phoneCode);
    return match ? match.name : "Unknown";
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <section>
      <HeaderFilter
        getUserList={getUserList}
        selectedTime
        setSelectedTimeselectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
      />

      <div className={`overflow-x-auto ${isLoading ? 'h-screen overflow-hidden' : ''}`}>
        <table className="min-w-full whitespace-nowrap border-0 rounded-md">
          <thead className="bg-[#F9F7FF] text-sm font-medium text-gray-700">
            <tr>
              {[
                { key: "name", label: "User Name" },
                { key: "email", label: "Email Address" },
                { key: "phone", label: "Phone Number" },
                { key: "createdAt", label: "Reg Date" },
                { key: "countryCode", label: "Country" },
                // { key: "lastSeen", label: "Last Seen" },
                // { key: "about", label: "About" },
              ].map(({ key, label }) => (
                <th
                  key={key}
                  className="px-4 py-4 font-medium cursor-pointer select-none"
                  onClick={() => handleSort(key)}
                >
                  <div className="flex items-center gap-2">
                    {label}
                    {sortConfig.key === key ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSort className="text-gray-300" />
                    )}
                  </div>
                </th>
              ))}
              <th className="px-4 py-4 font-medium">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {isLoading ? (
              <tr>
                <td colSpan="8" className="text-center p-5 bg-white">
                  Loading...
                </td>
              </tr>
            ) : sortedData.length > 0 ? (
              sortedData.map((user, index) => (
                <tr
                  key={index}
                  className={`bg-white hover:bg-gray-50 ${index === 0 ? "border-t-0" : ""
                    }`}
                >
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-3">
                      <img
                        src={user.userImage || user.avtarImage || profile_Img}
                        alt={user.name}
                        className="w-8 h-8 rounded-full object-cover"
                      />
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td className="px-4 py-4">{user.email || "-"}</td>
                  <td className="px-4 py-4">{user.phone || "-"}</td>
                  <td className="px-4 py-4">{user.createdAt ? formatDate(user.createdAt) : "-"}</td>
                  <td className="px-4 py-4">
                    {user.countryName || (user.countryCode ? getCountryFromPhoneCode(user.countryCode) : "-")}
                  </td>
                  {/* <td className="px-4 py-4">{user.lastSeen}</td> */}
                  {/* <td
                    className="px-4 py-4 max-w-[180px] cursor-pointer truncate"
                    title={user.about}
                    onClick={() => toggleMenu(index)}
                  >
                    {user.about}
                  </td> */}
                  <td className="px-4 py-4 flex items-center gap-3 text-gray-600">
                    <button
                      title="Edit"
                      className="bg-[#F9F7FF] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#7104F8] hover:opacity-50"
                      onClick={() => {
                        setSelectedUser(user);
                        openAddUserModal();
                      }}
                    >
                      <LuPencil />
                    </button>
                    {/* <button
                      title="Block"
                      className="bg-[#FFEFEE] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                      onClick={() => openModal("block")}
                    >
                      <IoBan />
                    </button> */}
                    <button
                      title="Delete"
                      className="bg-[#FFEFEE] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                      onClick={() => {
                        setSelectedUser(user);
                        openModal("delete");
                      }}
                    >
                      <GoTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center bg-white py-2">
                  No user found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!isLoading && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalItems={totalUsers}
          itemsPerPage={10}
          onPageChange={(page) => {
            getUserList(page);
          }}
        />
      )}
      {isBlockModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box relative bg-white">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold">Block User</h2>

              <MdClose onClick={() => closeModal("block")} size={18} />
            </div>

            {/* Image */}
            <div className="flex justify-center mb-4">
              <img
                src={BlockVec} // <-- replace with your actual path
                alt="Block warning"
              />
            </div>

            {/* Block confirmation content */}
            <p className="capitalize text-md mb-2 text-center font-bold text-xl">
              Are you sure to block user?
            </p>
            <p className="text-sm text-gray-600 mb-8 text-center">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum
            </p>
            <div className="flex justify-center gap-10 mt-4">
              <button
                onClick={() => closeModal("block")}
                className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
              >
                Cancel
              </button>
              <button
                onClick={() => closeModal("block")}
                className="btn btn-error bg-[#F44336] btn-sm min-w-30 rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
              >
                Yes, Block
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box relative bg-white">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold">Delete User</h2>

              <MdClose
                onClick={() => {
                  setSelectedUser(null);
                  closeModal("delete");
                }}
                size={18}
              />
            </div>

            {/* Image */}
            <div className="flex justify-center mb-4">
              <img
                src={DeleteVec} // <-- replace with your actual path
                alt="Block warning"
              />
            </div>

            {/* Block confirmation content */}
            <p className="capitalize text-md mb-2 text-center font-bold text-xl">
              Are you sure to delete user?
            </p>
            <p className="text-sm text-gray-600 mb-8 text-center">
              This action cannot be undone. Do you want to proceed?
            </p>
            <div className="flex justify-center gap-10 mt-4">
              <button
                onClick={() => {
                  setSelectedUser(null);
                  closeModal("delete");
                }}
                className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setIsDeleting(true);
                  const res = await deleteUser();
                  if (res) {
                    closeModal("delete");
                  }
                  setIsDeleting(false);
                }}
                disabled={isDeleting}
                className="btn btn-default bg-[#7104F8] btn-sm min-w-30 rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
              >
                {isDeleting ? "Deleting..." : "Yes, Delete It!"}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
